import { notifications } from '@mantine/notifications';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ErrorIcon, Success } from '@apple/assets/icons';
import { useTranslation } from '@apple/lib/i18next';
import { useBackOrNavigate } from '@apple/lib/tanstack-router/hooks/use-router-history';
import { DetailsLayout } from '@apple/ui/layouts/DetailsLayout';
import { ServerValidationError } from '@apple/utils/api/errors';

import { KeywordForm } from '@apple/features/keyword/KeywordForm';
import { saveKeywords } from '@apple/features/product/api/keywords';
import { productQueryKeys } from '@apple/features/product/queries/management';

export const Route = createFileRoute('/_authed/_admin/manage/keywords_/add')({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation('keywords');
	const queryClient = useQueryClient();
	const goBackToList = useBackOrNavigate();

	const addKeywordProductsMutation = useMutation({
		mutationFn: saveKeywords,
		onSuccess: async () => {
			notifications.show({
				color: 'green',
				message: t('add.success'),
				icon: <Success />,
			});
			await queryClient.invalidateQueries({ queryKey: productQueryKeys.keywords });
			await goBackToList('/manage/keywords');
		},
		onError: (error: Error) => {
			if (!(error instanceof ServerValidationError)) {
				notifications.show({
					message: t('common:error.generic'),
					icon: <ErrorIcon />,
					color: 'red',
					autoClose: 5000,
				});
			}
		},
	});

	return (
		<DetailsLayout title={t('title.add')}>
			<KeywordForm
				initialProducts={[]}
				onChange={addKeywordProductsMutation.mutateAsync}
				isSaving={
					addKeywordProductsMutation.isPending || addKeywordProductsMutation.isSuccess
				}
			/>
		</DetailsLayout>
	);
}
